import swal from 'sweetalert2'

export function divisionPopup(division, i18n) {
  return swal.fire({
    type: 'question',
    title: i18n.t('zones.new_title_for_zone'),
    html: `
      <input type="text" class="swal2-input" id="division-name"
        value="${division.title}">
      <div class="form-check text-left division-is-new">
        <input class="form-check-input" type="checkbox" value="1"
          id="division-is-new"
          ${division.isNewMethod ? 'checked' : ''}
        >
        <label class="form-check-label" for="division-is-new">
          ${i18n.t('divisions.new_method')}
      </label>
    `,
    showCancelButton: true,
    preConfirm: () => {
      const name = document.getElementById('division-name').value

      if (name.trim().length === 0) {
        swal.showValidationMessage(
          i18n.t('divisions.validation.name_cannot_be_empty'),
        )
        return false
      }

      return {
        name,
        isNewMethod: document.getElementById('division-is-new').checked,
      }
    },
  })
}
